import type { IntlShape, MessageDescriptor } from 'react-intl';
import type {
  AtaAzureServiceEnum,
  AzureExperienceEnum,
  BusinessExpertiseEnum,
  BusinessModelEnum,
  BvRegistrationTypesEnum,
  ConceptStageEnum,
  ExpertTypeEnum,
  FundingStageEnum,
  IndustryEnum,
  LanguageEnum,
  LevelPrefenceEnum,
  ProductCategoryEnum,
  ProductExpertiseEnum,
  RaceEthnicityEnum,
  SocialImpactEnum,
  SupportCaseCategoryEnum,
  TechnologyExpertiseEnum,
  YearRangeEnum,
} from '@foundershub/api-client';

export * from './ata-azure-service';
export * from './azure-experience';
export * from './business-expertise';
export * from './business-model';
export * from './concept-stage';
export * from './funding-stage';
export * from './industry';
export * from './level-preference';
export * from './product-category';
export * from './product-expertise';
export * from './race-ethnicity';
export * from './social-impact';
export * from './support-category';
export * from './technology-expertise';

export type MetaEnums =
  | AtaAzureServiceEnum
  | AzureExperienceEnum
  | BusinessModelEnum
  | ConceptStageEnum
  | FundingStageEnum
  | IndustryEnum
  | ProductCategoryEnum
  | RaceEthnicityEnum
  | SocialImpactEnum
  | ExpertTypeEnum
  | ProductExpertiseEnum
  | TechnologyExpertiseEnum
  | BusinessExpertiseEnum
  | LanguageEnum
  | YearRangeEnum
  | LevelPrefenceEnum
  | BvRegistrationTypesEnum
  | SupportCaseCategoryEnum;

export function dropdownOptions<D extends Array<L>, L extends MetaEnums>(
  data: D,
  labels: Record<L, MessageDescriptor>,
  formatMessage: IntlShape['formatMessage']
): Array<{ label: string; value: L }> {
  return data.map((slug) => {
    if (process.env.NODE_ENV === 'test' && !(slug in labels)) {
      throw new Error(`missing translation for ${slug}`);
    }
    const label = labels[slug];
    return {
      label: formatMessage(label),
      value: slug,
    };
  });
}
